export enum FORM_MODE {
  NEW = 'new',
  EDIT = 'edit',
  DELETE = 'delete',
}
